import { Logger } from '../../lib/logger';
export const muteError = (error) => {
    Logger.error(error);
};
export const banner = (data) => ({
    ...data,
    placement: 'banner'
});
export const autoBanner = (data, timeout = 5000) => ({
    placement: 'banner',
    timeout,
    ...data
});
export const errorBanner = (data) => ({
    ...autoBanner(data),
    type: 'error',
    placement: 'banner'
});
export const successBanner = (data) => ({
    ...autoBanner(data),
    type: 'success',
    placement: 'banner'
});
export const infoBanner = (data) => ({
    ...autoBanner(data),
    type: 'info',
    placement: 'banner'
});
export const toast = (data) => ({
    ...data,
    placement: 'toast'
});
export const autoToast = (data, timeout = 5000) => ({
    ...data,
    placement: 'toast',
    timeout
});
export const errorToast = (data) => ({
    ...autoToast(data),
    type: 'error',
    placement: 'toast'
});
export const successToast = (data) => ({
    ...autoToast(data),
    type: 'success',
    placement: 'toast'
});
export const infoToast = (data) => ({
    ...autoToast(data),
    type: 'info',
    placement: 'toast'
});
export const modal = (data) => ({
    ...data,
    placement: 'modal'
});
export const autoModal = (data, timeout = 5000) => ({
    ...data,
    placement: 'modal',
    timeout
});
export const errorModal = (data) => ({
    ...autoModal(data),
    type: 'error',
    placement: 'modal'
});
export const successModal = (data) => ({
    ...autoModal(data),
    type: 'success',
    placement: 'modal'
});
export const infoModal = (data) => ({
    ...autoModal(data),
    type: 'info',
    placement: 'modal'
});
